import { AbandonedVehicleStatus } from "../api/Network";

export const abandonedVehicleStatuses = [
    AbandonedVehicleStatus.Candidate,
    AbandonedVehicleStatus.ReviewedUnsure,
    AbandonedVehicleStatus.ReviewedRejected,
    AbandonedVehicleStatus.ReviewedRejectedIdentity,
    AbandonedVehicleStatus.ReviewedRejectedMoved,
    AbandonedVehicleStatus.ReviewedRejectedNotAVehicle,
    AbandonedVehicleStatus.ReviewedRejectedDeparted,
    AbandonedVehicleStatus.ReviewedRejectedArrived,
    AbandonedVehicleStatus.ReviewedVerified,
    AbandonedVehicleStatus.InPersonUnsure,
    AbandonedVehicleStatus.InPersonVerified,
    AbandonedVehicleStatus.InPersonRejected,
    AbandonedVehicleStatus.Impounded,
    AbandonedVehicleStatus.Released,
    AbandonedVehicleStatus.Scrapped,
];